function Footer() {
  return (
    <footer>
        <p id="footer--copyright">© {new Date().getFullYear()} Land Use Research Associates Inc. All rights reserved.</p>
        <a id="footer--lura-main-website" href="https://lura.ca/" target="_blank" rel="noreferrer" title="Open the main LURA website in a new window">lura.ca<span className="material-icons open-external">open_in_new</span></a>
    </footer>
  )
}

export default Footer